// extracted by mini-css-extract-plugin
module.exports = {"modalWindow":"General_modalWindow__2yqUL","closeIcon":"General_closeIcon__dcUNF","overlay":"General_overlay__rM6uI"};